<template>
  <!-- 임시 팝업 -->
  <div v-if="tempPopup" class="temp_popup">
    <div ref="inner" class="temp_popup_inner">
      <div class="temp_popup_top">
        <i class="icon"
          ><img src="@/assets/images/exclamation.png" alt="안내아이콘"
        /></i>
        <h2>📚 내서재 업데이트 안내</h2>
        <ul class="update_list">
          <li>✔ 책 표지를 누르면 바로 뷰어 진입</li>
          <li>✔ 책장으로 도서 정리</li>
          <li>✔ 검색으로 도서 빠르게 찾기</li>
        </ul>
        <p class="ment">지금 내서재에서 바로 확인하실 수 있어요.</p>
      </div>
      <div class="temp_popup_btn_wrap">
        <button class="forever_nonview" @click="hideForever">
          다시보지않기
        </button>
        <button class="check_confirm" @click="hideOne">확인</button>
      </div>
    </div>
  </div>
  <!-- ###### 임시 팝업 -->
</template>
<script>
export default {
  name: 'TempPopup',
  data() {
    return {
      tempPopup: false,
      isMobile: false,
      popupVersion: '2025-06-02' // 날짜 형식으로 버전 관리
    }
  },
  async mounted() {
    document.addEventListener('click', this.checkWindowSize)
    document.addEventListener('click', this.handleOutsideClick)
    this.clearOldPopupSettings(this.popupVersion)
    this.checkPopupStatus()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.checkWindowSize)
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    checkPopupStatus() {
      // 팝업 버전별 키 생성
      const foreverHideKey = `foreverHidePopup_${this.popupVersion}`
      const tempHideKey = `tempHidePopup_${this.popupVersion}`

      // 영구적으로 보지 않기 확인 (버전별)
      const foreverHide = localStorage.getItem(foreverHideKey)

      // 임시 숨김 확인 (버전별)
      const tempHide = sessionStorage.getItem(tempHideKey)

      // 현재 시간 가져오기
      const now = new Date()

      // 2025년 5월 12일 17:50 설정 (종료 시간)
      const endDate = new Date(2025, 5, 30, 17, 50, 0) // 월은 0부터 시작하므로 5월은 4

      // 종료 시간 키도 버전별로 관리
      const endDateKey = `popupEndDatePassed_${this.popupVersion}`

      // 현재 시간이 종료 시간 이후인지 확인
      if (now >= endDate) {
        // 종료 시간 이후라면 팝업 영구 숨김 처리 (버전별)
        localStorage.setItem(endDateKey, 'true')
        this.tempPopup = false
        return
      }

      // 이미 종료 시간을 지났는지 확인 (페이지 재방문 시)
      const endDatePassed = localStorage.getItem(endDateKey)
      if (endDatePassed === 'true') {
        this.tempPopup = false
        return
      }

      // 영구 숨김이나 임시 숨김 설정이 되어있지 않을 때만 팝업 표시
      if (foreverHide !== 'true' && !tempHide) {
        this.tempPopup = true
      } else {
        this.tempPopup = false
      }
    },
    hideForever() {
      // 버전별 키 사용
      const foreverHideKey = `foreverHidePopup_${this.popupVersion}`
      localStorage.setItem(foreverHideKey, 'true')
      this.tempPopup = false
    },
    hideOne() {
      // 버전별 키 사용
      // const tempHideKey = `tempHidePopup_${this.popupVersion}`
      // sessionStorage.setItem(tempHideKey, 'true')
      this.tempPopup = false
    },
    // 새로운 메서드: 특정 버전 이하의 팝업 설정 모두 제거 (선택적)
    clearOldPopupSettings(maxVersion) {
      // localStorage 내의 모든 키를 확인
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        // 팝업 관련 키인지 확인
        if (
          key.startsWith('foreverHidePopup_') ||
          key.startsWith('popupEndDatePassed_')
        ) {
          // 버전 추출 (예: 2025-05-01)
          const version = key.split('_')[1]
          // 지정된 버전보다 오래된 설정은 제거
          if (version < maxVersion) {
            localStorage.removeItem(key)
          }
        }
      }

      // sessionStorage도 동일하게 처리
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i)
        if (key.startsWith('tempHidePopup_')) {
          const version = key.split('_')[1]
          if (version < maxVersion) {
            sessionStorage.removeItem(key)
          }
        }
      }
    },
    handleOutsideClick(event) {
      if (
        this.isMobile &&
        this.$refs.inner &&
        !this.$refs.inner.contains(event.target)
      ) {
        this.tempPopup = false
      }
    },
    checkWindowSize() {
      const width = window.innerWidth
      this.isMobile = width <= 480
    }
  }
}
</script>
<style lang="scss" scoped>
.temp_popup {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  width: 100%;
  height: 100%;
}
.temp_popup_inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  // height: 407px;
  background: #fff;
  border-radius: 10px;
  padding: 30px 30px;
  user-select: none;
}
.temp_popup_btn_wrap {
  display: flex;
  gap: 8px;
  height: 45px;
}
.temp_popup_btn_wrap button {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  letter-spacing: 0.4px;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 16px;
}
.forever_nonview {
  border: 1px solid #56678942;
  color: #15192080;
}
.check_confirm {
  background: #2b4bf2;
  color: #fff;
}
.temp_popup_top {
  h2 {
    margin-bottom: 25px;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 22px;
  }
}
.update_list {
  li {
    margin-bottom: 5px;
    font-family: 'pretendard-medium';
    font-size: 18px;
  }
}
.ment {
  margin: 18px 0;
  font-size: 16px;
  color: #15192080;
}
.icon {
  display: block;
  width: 40px;
  height: 40px;
  margin-bottom: 25px;
  img {
    width: 100%;
    height: 100%;
    -webkit-user-drag: none;
  }
}
@media (max-width: 480px) {
  .temp_popup_inner {
    padding: 25px 25px;
    width: 310px;
  }
  .temp_popup_top h2 {
    margin-bottom: 15px;
    font-size: 19px;
  }
  .update_list li {
    font-size: 15px;
  }
  .ment {
    margin: 14px 0;
    font-size: 14px;
  }
  .temp_popup_btn_wrap {
    height: 39px;
  }
  .temp_popup_btn_wrap button {
    font-size: 13px;
  }
  .icon {
    margin-bottom: 15px;
  }
}
</style>
